import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=4ac316f0&scoped=true"
import script from "./AreaChart.vue?vue&type=script&lang=js"
export * from "./AreaChart.vue?vue&type=script&lang=js"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=4ac316f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac316f0",
  null
  
)

export default component.exports